<template>
  <PrimeVueButton
    :label="label"
    :icon="icon"
    :icon-pos="iconPos"
    :style="styles"
    @click="$emit('click', $event)"
  />
</template>

<script>
import PrimeVueButton from 'primevue/button'

export default {
  name: 'Button',
  components: { PrimeVueButton },
  props: {
    label: {
      type: String,
      default: 'Button',
    },
    icon: {
      type: String,
      default: null,
    },
    iconPos: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'right', 'top', 'bottom'].includes(value),
    },
    customClass: {
      type: String,
      default: '',
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    computedClass() {
      return `p-button ${this.customClass}`
    },
  },
}
</script>

<style scoped>
.p-button {
  margin-left: 10px;
  height: 45px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 20px;
  color: #fff;
  background-color: #64b4c8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}

.p-button:hover {
  opacity: 0.8;
}

.p-button-icon {
  margin-left: 8px;
}

.p-button-sm {
  padding: 8px 16px;
}

.p-button-lg {
  padding: 12px 24px;
}
</style>
